(function($) {
	'use strict';

	function bindEvents() {

		var termsWrap = document.querySelectorAll('[data-agree-to-terms]')[0];
		var checkWrap = termsWrap.querySelectorAll('[data-check-wrap]')[0];
		var check = termsWrap.querySelectorAll('input[type="checkbox"]')[0];
		var submit = termsWrap.querySelectorAll('button[type="submit"]')[0];

		check.addEventListener("change", function() {
	    if (check.checked) {
	    	submit.disabled = false;
	    } else {
	    	submit.disabled = true;
	    }
		});

		termsWrap.addEventListener("click", function() {
			if(submit.disabled) {
				checkWrap.classList.remove('has-success');
				checkWrap.classList.add('has-error');
				return;
			} else {
				checkWrap.classList.remove('has-error');
				checkWrap.classList.add('has-success');
			}
		});
	}

	function init() {
		bindEvents();
	}

	if ($('[data-agree-to-terms]').length > 0) {
		init();
	}

})($jq);
